import React, { Component } from 'react';
import { Modal, Select, Button, Spin, Icon, message } from 'antd';
import {
	WALLET_SELECTED,
	WALLET_BLUE_SELECTED,
	ICON_BOX,
	ICON_CHARGE,
	ICON_WAVE,
	ICON_LIST,
	HOLLAEX_NETWORK_WHITE
} from '../../config/media';

import {
	Cotainer,
	InfoSection,
	MainSection
} from '../../components/AppWrapper';
import GetXht from '../../components/GetXht';
import {
	createWalletAddress,
	getFeeData,
	confirmWithdrawal,
	getCollateral,
	getUserInfo
} from '../../common/fetch';

import WalletBalance from './WalletBalance';
import LeanMore from './LearnMore';
import HexDeposit from './HexDeposit';
import Withdrawal from './Withdrawal';
import SideBar from '../../components/SideBar';
import StakedXHT from './StakedXHT';
import { getTabParams } from '../../common/utils'
import History from './History'
import Wrapper from './style';

const { Option } = Select;

class Credit extends Component {
	state = {
		visible: false,
		isLoading: true,
		type: 0,
		isOpenDeposit: false,
		isOpenWithdraw: false,
		fees: {},
		isConfirmed: false,
		mobileToggle: false,
		selectedCoin: '',
		tabParams: getTabParams(),
		selectedCoinName: '',
		selectedCoinBalance: {},
		networks: ''
	};

	componentDidMount() {
		const { user, location, exchange } = this.props;
		if (location.pathname.indexOf('confirm-withdraw') >= 0) {
			if (!this.state.isConfirmed) {
				this.confirmRequest();
			}
		}
		setTimeout(() => {
			this.getFeeData();
		}, 1000);
		if (
			(user.balance.xht_available === undefined ||
				user.balance.xht_available === 0) &&
			location.state &&
			!location.state.account
		) {
			this.setState({ type: 1 });
		} else {
			this.setState({ type: 0 });
		}
		if (!user.crypto_wallet.hasOwnProperty('xht')) {
			this.generateXhtWallet();
		}
		if (this.state.tabParams && this.state.tabParams.type) {
			this.setState({
				type: parseInt(this.state.tabParams.type)
			})
		}
		if (exchange) {
			this.getData(exchange.id)
		}
	}

	confirmRequest = async () => {
		const { location } = this.props;
		const pathArr = location.pathname.split('/');
		try {
			const body = {
				token: pathArr[pathArr.length - 1]
			};
			await confirmWithdrawal(body);
			Modal.success({
				title: 'Success',
				content: 'Your withdrawal was successful processed.'
			});
			this.setState({ isConfirmed: false });
		} catch (error) {
			Modal.error({
				title: 'Failed',
				content: error.data.message
			});
			this.setState({ isConfirmed: false });
		}
	};

	getFeeData = async () => {
		try {
			const res = await getFeeData();
			this.setState({
				fees: res.data.coins,
				isLoading: false
			});
		} catch (error) {
			console.error(error.response);
			this.setState({ isLoading: false });
		}
	};

	generateXhtWallet = async () => {
		const { user, userActions } = this.props;
		try {
			const res = await createWalletAddress('xht');
			user.crypto_wallet['xht'] = res.data.address;
			userActions.updateData(user);
		} catch (error) { }
	};

	openChargePopup = () => {
		this.setState({ visible: true });
	};

	handleOk = () => {
		this.handleCancel();
	};

	handleCancel = () => {
		this.setState({ visible: false });
	};

	getData = async (id) => {
		try {
			const res = await getCollateral(id);
			const { data } = res;
			this.props.actions.setCollateral(data);
		} catch (error) {
			console.error(error);
		}
	};

	getUser = async () => {
		const { userActions } = this.props;
		try {
			const userInfo = await getUserInfo();
			userActions.readData(userInfo.data);
		} catch (error) {
			if (error.data && error.data.message) {
				message.error(error.data.message);
			}
		}
	};

	getCryptoAddress = async (crypto, network) => {
		try {
			await createWalletAddress(crypto, network);
			await this.getUser();
			message.success('Address created');
		} catch (error) {
			console.error(error);
			if (error.data && error.data.message) {
				message.error(error.data.message);
			}
		}
	};

	openPopup = (key, symbol, fullname, network = '') => {
		this.setState({
			[key]: true,
			selectedCoin: symbol,
			selectedCoinName: fullname,
			networks: network ? network.split(',') : ''
		});
	};

	handleClosePopup = () => {
		this.setState({
			isOpenDeposit: false,
			isOpenWithdraw: false,
			selectedCoin: '',
			networks: '',
			selectedCoinName: ''
		});
	};

	render() {
		const {
			type,
			visible,
			isOpenDeposit,
			isOpenWithdraw,
			fees,
			mobileToggle,
			selectedCoin,
			isLoading,
			selectedCoinName,
			networks
		} = this.state;
		const { coin, user = {}, exchange, userActions, history, collateral, updateCollateral, actions, constant } = this.props;
		const OptionImgProps = {
			height: '15px',
			verticalAlign: 'middle',
			marginRight: '8px'
		};

		let increment_unit;
		coin.forEach(data => {
			if (data.symbol === selectedCoin) {
				increment_unit = data.increment_unit
			}
		})

		if (isLoading) {
			return (
				<Wrapper>
					<Spin />
				</Wrapper>
			);
		}
		return (
			<Cotainer>
				<SideBar>
					<InfoSection className={mobileToggle ? 'less-content on' : 'less-content'}>
						<div className={constant.isExchangeExpired ? "expired-status" : ""}>
							<div className="info-title-wrapper">
								<img src={WALLET_SELECTED} alt="logo" className="title-icon" />
								<h3 className="title-label">Account Wallet</h3>
							</div>
							<p>Deposit coins in your account wallet and use it to pay for crypto services. Using crypto such as XHT will grant discounts on purchases.</p>
							<Button
								block
								type="primary"
								onClick={() => {
									if (window.innerWidth < 1200) {
										this.setState({ mobileToggle: false, type: 0 });
									} else {
										this.setState({ type: 0 });
									}
								}}
							>
								<img src={WALLET_BLUE_SELECTED} alt="account" />
								Wallet Balance
							</Button>
							<Button
								block
								type="primary"
								onClick={() => this.setState({ type: 1 })}
								className={this.state.type === 1 ? "btn-hover" : ""}
							>
								<Icon
									type="clock-circle"
									className="clock-icon"
									theme="filled"
								/>
								Wallet History
							</Button>
							{/*
							<Button block type="primary" onClick={this.openChargePopup}>
								<img src={ICON_CHARGE} alt="account" />
								Charge XHT Balance
							</Button>
							*/}
							<Button block type="primary">
								<a
									href=' https://pro.hollaex.com/trade/xht-usdt'
									target="_blank"
									rel="noopener noreferrer"
									style={{color:'#fff'}}
								>
									<img src={HOLLAEX_NETWORK_WHITE} alt="plugin" class="nav-icon" />HollaEx Pro Exchange
								</a>
							</Button>
							{/* <Button block type="primary">
								<a
									href="https://pro.hollaex.com/"
									title="wave auction"
									target="_blank"
									rel="noopener noreferrer"
									onClick={() => {
										if (window.innerWidth < 1200) {
											this.setState({ mobileToggle: false });
										}
									}}
								>
									<img src={ICON_WAVE} alt="account" />
									Wave Action
								</a>
							</Button> */}
							{/* <Button
								block
								type="primary"
								onClick={() => {
									if (window.innerWidth < 1200) {
										this.setState({ mobileToggle: false, type: 1 });
									} else {
										this.setState({ type: 1 });
									}
								}}
							>
								<img src={ICON_LIST} alt="account" />
								Learn More
							</Button> */}
							<Select defaultValue="Account Balance">
								<Option
									value="Account Balance"
									block
									type="primary"
									onClick={() => {
										if (window.innerWidth < 1200) {
											this.setState({ mobileToggle: false, type: 0 });
										} else {
											this.setState({ type: 0 });
										}
									}}
								>
									<img
										style={OptionImgProps}
										src={ICON_BOX}
										alt="account"
									/>
									Account Balance
								</Option>
								<Option
									value="Charge Balance"
									block
									type="primary"
									onClick={this.openChargePopup}
								>
									<img
										style={OptionImgProps}
										src={ICON_CHARGE}
										alt="account"
									/>
									Charge Balance
								</Option>
								<Option block type="primary" value="Wave Action">
									<a
										href="https://pro.hollaex.com/"
										title="wave auction"
										target="_blank"
										rel="noopener noreferrer"
										onClick={() => {
											if (window.innerWidth < 1200) {
												this.setState({ mobileToggle: false });
											}
										}}
									>
										<img
											style={OptionImgProps}
											src={ICON_WAVE}
											alt="account"
										/>
										Wave Action
									</a>
								</Option>
								<Option
									value="Learn More"
									block
									type="primary"
									onClick={() => {
										if (window.innerWidth < 1200) {
											this.setState({ mobileToggle: false, type: 1 });
										} else {
											this.setState({ type: 1 });
										}
									}}
								>
									<img
										style={OptionImgProps}
										src={ICON_LIST}
										alt="account"
									/>
									Learn More
								</Option>
							</Select>
						</div>
					</InfoSection>
				</SideBar>
				<MainSection>
					<Wrapper className={type === 1 ? "history-wrapper" : ""}>
						{type === 0 ? (
							<WalletBalance
								coins={coin}
								exchange={exchange}
								constant={constant}
								balance={user.balance}
								crypto_wallet={user.crypto_wallet}
								userAction={userActions}
								handleClick={this.openChargePopup}
								openDeposit={(symbol, fullname, network) => {
									this.openPopup('isOpenDeposit', symbol, fullname, network);
								}}
								openWithdraw={(symbol, fullname, network) => {
									this.openPopup('isOpenWithdraw', symbol, fullname, network);
								}}
							/>
						) : (type === 1
							?
							<History />
							: (type === 2
								?
								<StakedXHT
									history={history}
									collateral={collateral}
									exchange={exchange}
									user={user}
									updateCollateral={updateCollateral}
									actions={actions}
								/>
								:
								<LeanMore
									coin={coin}
									user={user}
									actions={userActions}
									checkDeposit={() => this.setState({ isOpenDeposit: true })}
								/>
							)
						)
						}

						{visible ? (
							<GetXht
								visible={true}
								handleCancel={this.handleCancel}
								handleOk={this.handleOk}
							/>
						) : null}
						<HexDeposit
							visible={isOpenDeposit}
							symbol={selectedCoin}
							wallet={user.wallet}
							fullname={selectedCoinName}
							balance={user.balance}
							getCryptoAddress={this.getCryptoAddress}
							exchange={exchange}
							networks={networks}
							onOk={this.handleClosePopup}
							onCancel={this.handleClosePopup}
						/>
						{isOpenWithdraw
							? <Withdrawal
								visible={isOpenWithdraw}
								symbol={selectedCoin}
								fees={fees}
								user={user}
								fullname={selectedCoinName}
								balance={user.balance}
								networks={networks}
								onOk={this.handleClosePopup}
								onCancel={this.handleClosePopup}
								increment_unit={increment_unit}
							/>
							: null
						}
					</Wrapper>
				</MainSection>
			</Cotainer>
		);
	}
}

export default Credit;
